"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledButton = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _localization = require("@lt/localization");

var _Context = require("./Context");

var _Button = _interopRequireDefault(require("../Button"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var PricewatchSubscribeFormRetryButton = function PricewatchSubscribeFormRetryButton() {
  var _useContext = (0, _react.useContext)(_Context.SubscribeContext),
      state = _useContext.state,
      STATE = _useContext.STATE,
      setState = _useContext.setState,
      isMobile = _useContext.isMobile;

  var _useTranslation = (0, _localization.useTranslation)(),
      t = _useTranslation.t;

  if (state !== STATE.ERROR) return null;
  return /*#__PURE__*/_react["default"].createElement(StyledButton, {
    isMobile: isMobile,
    onClick: function onClick() {
      return setState(STATE.EDIT);
    }
  }, t('subscribe.retry'));
};

var StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "PricewatchSubscribeFormRetryButton__StyledButton",
  componentId: "sc-ruz7xd-0"
})(["width:100%;font-size:14px;background:transparent;display:flex;align-items:center;justify-content:center;z-index:1;position:relative;margin-top:4px;", ";"], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile && (0, _styledComponents.css)(["font-size:16px;height:48px;"]);
});
exports.StyledButton = StyledButton;
var _default = PricewatchSubscribeFormRetryButton;
exports["default"] = _default;